import { Role } from '../const';

/**
 * @function createRole
 * @param { array } roles
 * @param { string } groupId
 * @returns { array }
 */
function createRole(roles, groupId) {
	const newRoles = Array.from(roles);

	const newRole = {
		[Role.GroupId]: groupId,
		[Role.Id]: '-1',
		[Role.Name]: 'New role...',
		[Role.Desc]: '',
		[Role.Type]: '',
		[Role.Checked]: false,
	};

	newRoles.push(newRole);

	return newRoles;
}

export default createRole;
